// OrderCashCard.js
// Minimal card component for cash payments and refunds.
// Converts createdAt to Asia/Kolkata timezone and displays human-readable date/time.

import React from "react";
import { Card, Row, Col, Badge } from "reactstrap";

function get(obj, path, defVal) {
  try {
    var parts = String(path).split(".");
    var cur = obj;
    for (var i = 0; i < parts.length; i++) {
      if (cur == null) return defVal;
      cur = cur[parts[i]];
    }
    return cur == null ? defVal : cur;
  } catch (e) { return defVal; }
}

function toCurrencyString(v) {
  if (v === "" || v == null || isNaN(v)) return "";
  var n = Number(v);
  return n.toFixed(2);
}

function getVariant(node) {
  var t = String(get(node, 'ordertype', '')).toLowerCase();
  return t === 'cashrefund' ? 'refund' : 'cash';
}

function getAmount(node) {
  var variant = getVariant(node);
  if (variant === 'refund') {
    var r = get(node, 'refundamount', null);
    if (r == null && get(node, 'total', null) != null) return Number(get(node, 'total', 0));
    return r == null ? NaN : Number(r);
  }
  return Number(get(node, 'total', 0));
}

function formatDateKolkata(utcString) {
  if (!utcString) return '';
  try {
    var date = new Date(utcString);
    // Convert to Asia/Kolkata
    var options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    };
    return new Intl.DateTimeFormat('en-IN', options).format(date);
  } catch (e) {
    return String(utcString);
  }
}

export default function OrderCashCard(props) {
  var node = props && props.order ? (props.order.node ? props.order.node : props.order) : {};
  var token = get(node, 'storeToken', '');
  var orderId = get(node, 'orderId', get(node, 'order_id', ''));
  var createdAtRaw = get(node, 'createdAt', '');
  var status = get(node, 'status', '');
  var variant = getVariant(node);
  var amount = getAmount(node);
  var createdAt = formatDateKolkata(createdAtRaw);
  var statusUpper = String(status).toUpperCase();
  var isCompleted = statusUpper === 'PAID' || statusUpper === 'REFUNDED';

  var title = variant === 'refund' ? 'Refund' : 'Cash Payment';

  return (
    <Card
      onClick={function(){ if (typeof props.onClick === 'function') props.onClick(props.order); }}
      style={{ margin: 8, padding: 10, cursor: 'pointer', backgroundColor: isCompleted ? '#9ea0a3' : undefined }}
      className="order-cash-card"
    >
      <Row style={{ alignItems: 'center' }}>
        <Col xs="4" className="text-center" style={{ borderRight: '1px solid #eee' }}>
          <div style={{ fontSize: 12, margin: 0 }}>TOKEN</div>
          <div style={{ fontSize: 28, fontWeight: 'bold', marginTop: 2 }}>{String(token)}</div>
          {status ? (
            <div style={{ marginTop: 6 }}>
              <Badge color={status === 'NEW' ? 'info' : (status === 'READY' ? 'success' : 'secondary')}>
                {status}
              </Badge>
            </div>
          ) : null}
        </Col>
        <Col xs="8">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ fontWeight: 'bold' }}>{title}</div>
            <div style={{ fontWeight: 'bold' }}>
              {isNaN(amount) ? '' : ('₹ ' + toCurrencyString(amount))}
            </div>
          </div>
          <div style={{ fontSize: 12, marginTop: 4 }}>Order ID: {String(orderId)}</div>
          {createdAt ? (
            <div style={{ fontSize: 12, color: '#666' }}>Created: {createdAt}</div>
          ) : null}
        </Col>
      </Row>
    </Card>
  );
}


// WEBPACK FOOTER //
// ./src/components/OrderCard/OrderCashCard.js